import { useEffect } from 'react';

export const useShowModal = (myRef, visible) => {
  useEffect(() => {
    if (visible) myRef?.current?.showModal();
    if (!visible) myRef?.current?.close();
  }, [myRef, visible]);
};
